/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./download-basic.vue?vue&type=template&id=0d8675d0&scoped=true&"
import script from "./download-basic.vue?vue&type=script&lang=js&"
export * from "./download-basic.vue?vue&type=script&lang=js&"
import style0 from "./download-basic.vue?vue&type=style&index=0&id=0d8675d0&prod&lang=scss&scoped=true&"
import style1 from "./download-basic.vue?vue&type=style&index=1&id=0d8675d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8675d0",
  null
  
)

export default component.exports